<template>
  <div class="pa-6">
    <v-row>
      <v-col cols="12" md="8">
        <v-card outlined flat>
          <v-card-text class="pa-4">
            <h3 class="primary--text mb-4">{{ $t('guest.companyData.title') }}</h3>
            <v-form ref="form" v-model="valid" :disabled="loading">
              <label>{{ $t('guest.companyData.vatNumber') }}</label>
              <v-row no-gutters class="mb-2">
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="form.vatNumber"
                    outlined
                    dense
                    single-line
                    validate-on-blur
                    :rules="[v => !v || v.length <= 50 || $t('validation.maxChar')]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="auto" class="ml-md-3 mb-4">
                  <v-btn
                    color="primary"
                    depressed
                    :disabled="!form.vatNumber || gusLoading"
                    :loading="gusLoading"
                    @click="fetchFromGus"
                  >
                    {{ $t('guest.companyData.fetchGus') }}
                  </v-btn>
                </v-col>
              </v-row>
              <label>{{ $t('guest.companyData.companyName') }}</label>
              <v-text-field
                v-model="form.companyName"
                outlined
                dense
                single-line
                validate-on-blur
                :rules="[v => !v || v.length <= 200 || $t('validation.maxChar')]"
              ></v-text-field>
              <label>{{ $t('guest.companyData.street') }}</label>
              <v-text-field
                v-model="form.street"
                outlined
                dense
                single-line
                validate-on-blur
                :rules="[v => !v || v.length <= 200 || $t('validation.maxChar')]"
              ></v-text-field>
              <v-row no-gutters>
                <v-col cols="12" md="4" class="pr-md-3">
                  <label>{{ $t('guest.companyData.zipCode') }}</label>
                  <v-text-field
                    v-model="form.zipCode"
                    outlined
                    dense
                    single-line
                    validate-on-blur
                    :rules="[v => !v || v.length <= 20 || $t('validation.maxChar')]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <label>{{ $t('guest.companyData.city') }}</label>
                  <v-text-field
                    v-model="form.city"
                    outlined
                    dense
                    single-line
                    validate-on-blur
                    :rules="[v => !v || v.length <= 100 || $t('validation.maxChar')]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <label>{{ $t('guest.companyData.country') }}</label>
              <v-col cols="12" md="3" class="px-0">
                <CountryFlagSelect v-model="form.country" />
              </v-col>
              <div class="d-flex mt-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  :disabled="submitLoading"
                  :loading="submitLoading"
                  @click="submit"
                >
                  {{ $t('guest.companyData.save') }}
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import services from '@/services'
import { getGuestProfile, updateGuestCompanyData } from '@/services/guest'
import CountryFlagSelect from '@/components/CountryFlagSelect'

export default {
  name: 'GuestCompanyData',
  components: {
    CountryFlagSelect
  },
  data () {
    return {
      form: {
        companyName: '',
        vatNumber: '',
        street: '',
        zipCode: '',
        city: '',
        country: ''
      },
      loading: true,
      submitLoading: false,
      gusLoading: false,
      valid: true
    }
  },
  async created () {
    await this.fetchProfile()
  },
  methods: {
    async fetchProfile () {
      this.loading = true
      try {
        const { data } = await getGuestProfile()
        this.form.companyName = data.companyName
        this.form.vatNumber = data.vatNumber
        this.form.street = data.street
        this.form.zipCode = data.zipCode
        this.form.city = data.city
        this.form.country = data.country
      } catch (e) {}
      this.loading = false
    },
    async fetchFromGus () {
      this.gusLoading = true
      try {
        const { data } = await services.get('ExternalApi/GetGusByNip', { nip: this.form.vatNumber })
        this.form.companyName = data.name
        this.form.country = 'PL'
        this.form.city = data.city
        this.form.zipCode = data.postalCode
        this.form.street = `${data.street} ${data.streetNumber}`
      } catch (e) {}
      this.gusLoading = false
    },
    async submit () {
      this.$refs.form.validate()
      if (!this.valid) return
      this.submitLoading = true
      try {
        await updateGuestCompanyData({
          companyName: this.form.companyName,
          vatNumber: this.form.vatNumber,
          street: this.form.street,
          zipCode: this.form.zipCode,
          city: this.form.city,
          country: this.form.country
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('guest.companyData.saved'))
      } catch (e) {}
      this.submitLoading = false
    }
  }
}
</script>
